import { render, staticRenderFns } from "./Cols-66-33.vue?vue&type=template&id=55746b3d&scoped=true&"
import script from "./Cols-66-33.vue?vue&type=script&lang=js&"
export * from "./Cols-66-33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55746b3d",
  null
  
)

export default component.exports